import tradingJson from './content/trading.json';

export const tradingMock = {
    layoutType: 2,
    data: {
        name: 'trading',
        areasList: [
            {
                id: 1,
                name: 'TradingPage',
                componentName: 'Comp:TradingPage',
                content: JSON.stringify(tradingJson)
            }
        ]
    }
};
